const ExceptionCode = {
  RefreshTokenExpiredOrRevoked: 1000,
}

export { ExceptionCode }
export default ExceptionCode
